import { Link } from "react-router-dom";

const testimonials = [
  {
    name: "Marta Puig",
    location: "Eixample, Girona",
    text: "Vaciaron el piso de mi madre en un solo día. Profesionales, rápidos y muy discretos. El precio fue exactamente el del presupuesto, sin sorpresas. Totalmente recomendables.",
    rating: 5,
    initials: "MP",
  },
  {
    name: "Jordi Sala",
    location: "Salt",
    text: "Necesitaba vaciar un local comercial con urgencia para entregarlo al propietario. Me llamaron al día siguiente y en dos días estaba todo hecho. Servicio impecable.",
    rating: 5,
    initials: "JS",
  },
  {
    name: "Anna Ferrer",
    location: "Montilivi, Girona",
    text: "Tuvimos que gestionar una situación muy delicada de síndrome de Diógenes. El equipo actuó con una discreción y profesionalidad que agradecemos enormemente. Gracias.",
    rating: 5,
    initials: "AF",
  },
  {
    name: "Pere Mas",
    location: "Banyoles",
    text: "Pedí presupuesto por fotos y en pocas horas ya tenía respuesta. El precio fue justo y el trabajo, perfecto. Además pintaron el piso después y quedó como nuevo.",
    rating: 5,
    initials: "PM",
  },
  {
    name: "Laia Bosch",
    location: "Sant Narcís, Girona",
    text: "Heredamos una casa con muchos años de acumulación. GIROBUIT lo gestionó todo: vaciado, limpieza y pintura final. Un servicio integral que nos ahorró mucho tiempo.",
    rating: 5,
    initials: "LB",
  },
  {
    name: "Carles Vidal",
    location: "Cassà de la Selva",
    text: "Muy buena experiencia. Puntuales, limpios y eficientes. Dejaron el piso vacío y barrido. El presupuesto sin compromiso fue clave para decidirme. Repetiría sin duda.",
    rating: 5,
    initials: "CV",
  },
];

export default function Testimonials() {
  return (
    <section className="py-20 md:py-28 bg-[#f9f5f5]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-700 text-[#b30000] uppercase tracking-widest mb-3" style={{ fontWeight: 700 }}>
            Opiniones reales
          </span>
          <h2 className="text-3xl md:text-4xl font-800 text-[#330000] mb-4" style={{ fontWeight: 800 }}>
            Lo que dicen nuestros clientes en Girona
          </h2>
          <p className="text-gray-600 max-w-xl mx-auto text-base">
            Más de 500 familias y empresas en Girona y comarca han confiado en nosotros para sus{" "}
            <Link to="/servicios" className="text-[#b30000] hover:underline cursor-pointer font-600" style={{ fontWeight: 600 }}>
              vaciados de pisos y locales
            </Link>.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-white rounded-2xl p-7 flex flex-col gap-4"
              style={{ border: "1px solid rgba(255,0,0,0.08)" }}
            >
              <div className="flex gap-1">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#b30000] text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-gray-600 leading-relaxed flex-1">
                <span className="text-[#b30000] text-3xl font-900 leading-none mr-1" style={{ fontWeight: 900 }}>"</span>
                {t.text}
              </p>
              <div className="flex items-center gap-3 pt-2 border-t border-gray-100">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#FF6666] text-white text-sm font-700 flex-shrink-0" style={{ fontWeight: 700 }}>
                  {t.initials}
                </div>
                <div>
                  <div className="text-sm font-700 text-[#330000]" style={{ fontWeight: 700 }}>{t.name}</div>
                  <div className="text-xs text-gray-500">{t.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-12">
          <Link
            to="/contacto"
            className="inline-flex items-center gap-2 bg-[#330000] text-white px-8 py-4 rounded-full text-sm font-700 whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-[#ff0000] hover:scale-105"
            style={{ fontWeight: 700 }}
          >
            Pide tu presupuesto sin compromiso <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
